import React from 'react'

import styled from '@emotion/styled'
import SVGLoader from '@src/components/svg/SVGLoader'
import logo from '@src/images/logo/logo-260x54.png'
import { Link } from 'react-router-dom'
import useSignout from '@src/hooks/auth/signout/useSignout'

const Header = () => {
	const { getSignoutBtnProps } = useSignout()
	return (
		<>
			<HeaderLeft>
				<Logo src={logo} alt="logo" />
			</HeaderLeft>
			<HeaderRight>
				<Link to="/">
					<SVGLoader name="home" />
				</Link>
				<Button type="button" {...getSignoutBtnProps()}>
					로그아웃
				</Button>
			</HeaderRight>
		</>
	)
}

const HeaderLeft = styled.div`
	width: 13rem;
`

const Logo = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
`

const HeaderRight = styled.div`
	display: flex;
	align-items: center;
	svg {
		color: #92959e;
	}
`

const Button = styled.button`
	background: #f4f5f7;
	opacity: 0.85;
	border: none;
	border-radius: 0.5rem;
	font-size: 1.2rem;
	font-weight: 700;
	line-height: 1.9rem;
	color: #92959e;
	padding: 0.7rem 2.3rem;
	margin-left: 3rem;
`

export default Header
